import { Inject, Injectable } from '@angular/core';

import { MoneyService } from '@frontend/sports/common/core/feature/money';
import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { Observable, combineLatest, map, share } from 'rxjs';

import { IBetslipMessages } from '../../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../../base/services/betslip-messages-provider.service';
import { IPlaceBetButtonMessages } from '../../../../models';
import { IPlaceButtonState, PlaceButtonStates } from '../../../../state';
import { IPlaceButtonMessagesProvider, PLACE_BUTTON_MESSAGES_PROVIDER } from '../../place-button-messages-provider.service';
import { IPlaceButtonMessageService, IPlaceButtonStateService, PLACE_BUTTON_STATE_SERVICE } from '../interfaces/place-button-interfaces';

@Injectable()
export class BetslipPlaceButtonMessageService implements IPlaceButtonMessageService {
    buttonMessage$: Observable<string>;
    private messages: IBetslipMessages;
    constructor(
        @Inject(PLACE_BUTTON_STATE_SERVICE) placeButtonService: IPlaceButtonStateService,
        @Inject(PLACE_BUTTON_MESSAGES_PROVIDER) messagesProvider: IPlaceButtonMessagesProvider,
        private moneyService: MoneyService,
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) betslipMessageProvider: IBetslipMessagesProviderService,
    ) {
        const placeButtonState$ = placeButtonService.state$;
        const messages$ = messagesProvider.messages$;
        this.messages = betslipMessageProvider.getMessages();
        this.buttonMessage$ = combineLatest([placeButtonState$, messages$]).pipe(
            map(([state, messages]) => this.getButtonMessage(state, messages)),
            share(),
        );
    }

    private getButtonMessage(state: IPlaceButtonState, messages: IPlaceBetButtonMessages): string {
        const changedPicksAmount = state.changedPicks.closedPicks + state.changedPicks.lockedPicks;
        const suspendedPicks = state.changedPicks.suspendedPicks;
        if (state.action === PlaceButtonStates.AcceptChanges && changedPicksAmount > 0) {
            return interpolateDoubleBracesString(messages.lockedBetsToRemove, { count: changedPicksAmount });
        }
        if (state.action === PlaceButtonStates.UpdateStake || state.action === PlaceButtonStates.UpdateStakes) {
            const updateError = state.stakeUpdateErrors[0];
            const minStakeWithCurrency = {
                amountWithCurrency: this.moneyService.transform(updateError.error.minimumStake, true),
            };
            const message =
                state.action === PlaceButtonStates.UpdateStake ? this.messages.validation.MinStakeValue : this.messages.validation.MinStakePerBet;

            return interpolateDoubleBracesString(message, minStakeWithCurrency);
        }

        if (state.action !== PlaceButtonStates.Login && suspendedPicks > 0) {
            // return 'To place a bet, remove locked legs';
            return messages.RemoveSuspendedLegsToPlaceBet;
        }

        return '';
    }
}
